import { useQuery } from '@tanstack/react-query';
import { schoolBandsApi } from '@/features/reports/api';

export const schoolSizeCostFilterQueryKeys = {
  schoolBands: (year: string) => ['school-size-cost', 'schoolBands', year] as const,
};

/** GET /api/app/school-bands?Year=…&ExcludeDetails=true */
export function useSchoolSizeCostSchoolBandsQuery(year: string | undefined) {
  const y = year?.trim() ?? '';
  const yearNum = Number(y);
  const enabled = y !== '' && Number.isFinite(yearNum);

  return useQuery({
    queryKey: schoolSizeCostFilterQueryKeys.schoolBands(y),
    queryFn: () =>
      schoolBandsApi.getList({
        year: yearNum,
        excludeDetails: true,
        skipCount: 0,
        maxResultCount: 100,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
